import { render, staticRenderFns } from "./PersonScopeMultiPickerDialog.vue?vue&type=template&id=2465bca6&scoped=true"
import script from "./PersonScopeMultiPickerDialog.vue?vue&type=script&lang=js"
export * from "./PersonScopeMultiPickerDialog.vue?vue&type=script&lang=js"
import style0 from "./PersonScopeMultiPickerDialog.vue?vue&type=style&index=0&id=2465bca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2465bca6",
  null
  
)

export default component.exports